// Phase 999.4 Plan 07 — Step B: OrgLocation (Site) name + description + UTM JSON.
//
// SPEC R6 Step B requires Site name (mandatory) + description + UTM zone JSON.
// The server (Plan 04) stores utmJson verbatim in orglocation.Data; we validate
// here only that the string parses as a JSON object so a typo in Step B doesn't
// reach the server. Empty `{}` is acceptable per CONTEXT.
//
// No fetch is issued from this step — pure form state with inline validation.
// All fields dispatch SET_LOCATION with the merged location patch so the reducer
// stays simple (one action type for the whole sub-state).

import React from 'react';
import { Form, FormGroup, Label, Input, FormText } from 'reactstrap';

export function StepB_OrgLocation({ state, dispatch }) {
    const set = (patch) => dispatch({
        type: 'SET_LOCATION',
        location: { ...state.orglocation, ...patch },
    });

    // UTM JSON validity: parse must succeed AND yield a non-null object.
    // Used by both the Input invalid-flag and the inline error message below;
    // CreateSiteWizard.canProceed re-runs the same check before enabling Next.
    const utmValid = (() => {
        try {
            const o = JSON.parse(state.orglocation.utmJson || '{}');
            return typeof o === 'object' && o !== null && !Array.isArray(o);
        } catch { return false; }
    })();

    return (
        <Form>
            <h4>Step B — OrgLocation (Site)</h4>
            <FormGroup>
                <Label for="step-b-name">Site name</Label>
                <Input
                    id="step-b-name"
                    type="text"
                    value={state.orglocation.name}
                    onChange={(e) => set({ name: e.target.value })}
                    data-testid="step-b-name"
                />
                <FormText>Required. Maps to orglocation.Name.</FormText>
            </FormGroup>
            <FormGroup>
                <Label for="step-b-description">Description</Label>
                <Input
                    id="step-b-description"
                    type="textarea"
                    rows={2}
                    value={state.orglocation.description}
                    onChange={(e) => set({ description: e.target.value })}
                    data-testid="step-b-description"
                />
            </FormGroup>
            <FormGroup>
                <Label for="step-b-utm">UTM zone JSON</Label>
                <Input
                    id="step-b-utm"
                    type="text"
                    value={state.orglocation.utmJson}
                    onChange={(e) => set({ utmJson: e.target.value })}
                    invalid={!utmValid}
                    data-testid="step-b-utm"
                />
                <FormText>e.g. {'{"UTMZoneNum": 50, "UTMZoneLet": "K"}'}. Stored verbatim in orglocation.Data.</FormText>
                {!utmValid && <div className="text-danger small">UTM JSON must parse as a JSON object.</div>}
            </FormGroup>
        </Form>
    );
}

export default StepB_OrgLocation;
